export const PLAN_LIST = 'PLAN_LIST';
export const PLAN_LIST_SUCCESSFUL = 'PLAN_LIST_SUCCESSFUL';
export const PLAN_API_ERROR ="PLAN_API_ERROR";